import PropTypes from "prop-types";

import IconArrow from "assets/svg/down_arrow_icon.svg";

import styles from "./styles.module.css";

const getColor = (type) => {
  const selectedColors = {
    new: "text-carnation",
    promotion: "text-mysin",
    opportunity: "text-apple-light",
    premium: "text-nevada",
    proje: "text-apple-light",
    INSTALMENT: "text-apple-light",
    DELAY: "text-apple-light",
    DEPLETABLE: "text-tall-poppy",
    platinum: "text-pickledBluewood",
  };
  const isContainType = [
    "new",
    "promotion",
    "opportunity",
    "premium",
    "proje",
    "INSTALMENT",
    "DELAY",
    "DEPLETABLE",
    "platinum",
  ].includes(type);
  return isContainType ? selectedColors[type] : "text-standarts-black";
};

const getBadgeName = (type, data) => {
  const selectedLabels = {
    new: "YENİ",
    promotion: "ÖNE ÇIKAN",
    opportunity: "JETFIRSAT",
    premium: "PREMIUM",
    proje: "PROJE",
    DEPLETABLE: "TÜKENİYOR",
    INSTALMENT: `${data?.title} AY TAKSİT`,
    DELAY: `${data?.title} AY VADE`,
    platinum: "PLATİN",
  };
  const isContainType = [
    "new",
    "promotion",
    "opportunity",
    "premium",
    "proje",
    "DEPLETABLE",
    "INSTALMENT",
    "DELAY",
    "platinum",
  ].includes(type);
  return isContainType ? selectedLabels[type] : false;
};

const BadgeCard = (props) => {
  const { type, data } = props;
  const name = getBadgeName(type, data);
  if (!name) return null;

  const isPercentage = type.includes("%");

  return (
    <div className={`${styles.badgewrapper} ${getColor(type)}`}>
      {name}{" "}
      {isPercentage && (
        <span className={styles.icon}>
          <IconArrow />
        </span>
      )}
    </div>
  );
};

BadgeCard.propTypes = {
  type: PropTypes.string,
  badgeIcon: PropTypes.element,
  data: PropTypes.object,
};

export default BadgeCard;
